export const PlaybooksTabs = [
  {
    label: 'Chat',
    value: 'CHAT',
  },
  {
    label: 'Email',
    value: 'EMAIL',
  },
  {
    label: 'Sequence',
    value: 'SEQUENCE',
  },
  {
    label: 'Signature',
    value: 'SIGNATURE',
  }
]

export const PlaybookTabStatusOptions = {
  CHAT: [
    {
      label: 'Active Playbooks',
      value: 'ACTIVE',
      defaultSort: { property: 'priority', dir: 'asc' },
    },
    {
      label: 'Archived Playbooks',
      value: 'ARCHIVED',
    },
  ],
  EMAIL: [
    {
      label: 'Automated Playbooks',
      value: 'ACTIVE',
    },
    {
      label: 'Draft Playbooks',
      value: 'DRAFTS',
    },
    {
      label: 'Sent Playbooks',
      value: 'SENT',
    },
    {
      label: 'Archived Playbooks',
      value: 'ARCHIVED',
    },
    {
      label: 'Scheduled Playbooks',
      value: 'SCHEDULED',
    },
  ],
  SEQUENCE: [
    {
      label: 'Active Sequences',
      value: 'ACTIVE',
    },
    {
      label: 'Draft Sequences',
      value: 'DRAFTS',
    },
    {
      label: 'Archived Sequences',
      value: 'ARCHIVED',
    },
  ],
  SIGNATURE: [
    {
      label: 'Active Signatures',
      value: 'ACTIVE',
    },
    {
      label: 'Archived Signatures',
      value: 'ARCHIVED',
    },
  ]
}

export const makePlaybooksTableColumns = (onChange, tableState = 'CHAT_ACTIVE') => {
  const priorityColumn = {
    label: <span className="playbook-list-table-header">Priority</span>,
    sortable: true,
    value: 'priority',
    onClick: onChange,
    width: '90px',
  }

  const nameAndEditColumns = [
    {
      label: <span className="playbook-list-table-header">Playbook</span>,
      sortable: true,
      value: 'name',
      onClick: onChange,
    },
    {
      label: null,
      sortable: false,
      value: 'edit',
      className: 'playbook-table-edit-cell'
    },
    {
      label: <span className="playbook-list-table-header">Playbook ID</span>,
      sortable: false,
      value: 'id',
      className: 'playbook-table-cell-id'
    }
  ]

  const lastUpdatedColumn = {
    label: <span className="playbook-list-table-header">Last Updated</span>,
    sortable: true,
    value: 'last_updated',
    onClick: onChange,
    className: 'playbook-table-last-updated-cell'
  }

  const nameEditAndUpdatedAtColumns = nameAndEditColumns.concat([lastUpdatedColumn])

  const statusColumn = {
    label: <span className="playbook-list-table-header">Status</span>,
    className: 'playbook-table-status-cell'
  }

  const scheduledForColumn = {
    label: <span className="playbook-list-table-header">Scheduled For</span>,
    value: 'scheduledFor',
    sortable: false,
  }

  const tableStateToColumnMap = {
    CHAT_ACTIVE: [priorityColumn]
      .concat(nameEditAndUpdatedAtColumns)
      .concat([statusColumn]),
    CHAT_ARCHIVED: nameEditAndUpdatedAtColumns,
    EMAIL_ACTIVE: nameEditAndUpdatedAtColumns.concat([statusColumn]),
    EMAIL_SCHEDULED: nameEditAndUpdatedAtColumns.concat([scheduledForColumn]),
    EMAIL_SENT: nameAndEditColumns.concat([lastUpdatedColumn]),
    EMAIL_DRAFTS: nameEditAndUpdatedAtColumns,
    EMAIL_ARCHIVED: nameAndEditColumns.concat([lastUpdatedColumn]),
    SEQUENCE_ACTIVE: nameEditAndUpdatedAtColumns.concat([statusColumn]),
    SEQUENCE_ARCHIVED: nameAndEditColumns.concat([lastUpdatedColumn]),
    SEQUENCE_DRAFTS: nameEditAndUpdatedAtColumns,
    SIGNATURE_ACTIVE: nameEditAndUpdatedAtColumns.concat([statusColumn]),
    SIGNATURE_ARCHIVED: nameEditAndUpdatedAtColumns,
  }

  return tableStateToColumnMap[tableState]
}

export const sortProperties = {
  PRIORITY: 'priority',
  NAME: 'name',
  LAST_UPDATED: 'last_updated',
}

export const sortDirections = {
  ASC: 'asc',
  DESC: 'desc',
}

export const defaultSort = { dir: sortDirections.DESC, property: sortProperties.LAST_UPDATED }

export const tableStates = {
  CHAT_ACTIVE: 'CHAT_ACTIVE',
  CHAT_ARCHIVED: 'CHAT_ARCHIVED',
  EMAIL_ACTIVE: 'EMAIL_ACTIVE',
  EMAIL_DRAFT: 'EMAIL_DRAFT',
  EMAIL_SENT: 'EMAIL_SENT',
  EMAIL_ARCHIVED: 'EMAIL_ARCHIVED',
  EMAIL_SCHEDULED: 'EMAIL_SCHEDULED',
  SEQUENCE_ACTIVE: 'SEQUENCE_ACTIVE',
  SEQUENCE_ARCHIVED: 'SEQUENCE_ARCHIVED',
  SEQUENCE_DRAFTS: 'SEQUENCE_DRAFTS',
  SIGNATURE_ACTIVE: 'SIGNATURE_ACTIVE',
  SIGNATURE_ARCHIVED: 'SIGNATURE_ARCHIVED',
}



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/PlaybooksTableContainer/constants.js